<template>
    
    <main>
        <div class="indigo darken-3">
            <slot/>
        </div>
    </main>
</template>
<script>
export default {
    name: 'AuthLayout',
    props: {
        title: String,
    },
    mounted() {
        document.title = this.title;
    }
}
</script>